import { createStyles } from "@mantine/core";

export const useFormStyles = createStyles(() => {
    return {
        form: {
            '> div': {
                marginBottom: '1rem'
            }
        }
    }
});